export { default } from "./list-property";
